module.exports = __webpack_public_path__ + "img/pattern_7.c56fbb3c.png";